var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwimwearWomen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.064s-1.104-2.832 0-5.088C20.248 8.384 19.528 2 19.528 2h-1.296c0 4.08-2.015 7.392-4.512 7.392-2.496 0-4.464-3.312-4.464-7.392H8.008s-.72 6.384.528 8.976c1.104 2.255 0 5.087 0 5.087L7 20.576S11.08 22.11 12.088 26H15.4c1.008-3.888 5.088-5.424 5.088-5.424L19 16.064z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgSwimwearWomen;